// Types
import { WorkshopModule, WorkshopModuleDefinition } from '../types';

/** Converts a module's authoring shape into the `WorkshopModule` the UI renders. */
export const defineModule = ({
  key,
  name,
  actionItems
}: WorkshopModuleDefinition): WorkshopModule => ({
  id: key,
  name,
  actionItems: actionItems.map((actionItem, index) => ({
    ...actionItem,
    id: `${key}-${index + 1}`
  }))
});
